export const FLOOR_FILTER_VALUES = {
    THIS_FLOOR: 'this-floor',
    ALL_FLOORS: 'all-floors',
};
// Language-independent sentinels for the availability filter. These are the
// values stored in filter state and compared against; translated strings are
// only ever used for display. The numeric duration options ('30', '60', '90')
// are already language-independent.
export const AVAILABILITY_FILTER_VALUES = {
    ANY: 'Any',
    ALL_DAY: 'AllDay',
};
// Allow-list of values that actually activate a duration/availability filter.
// An unexpected or stale value degrades safely to "no availability filter".
export const DURATION_AVAILABILITY_VALUES = new Set([
    '30',
    '60',
    '90',
    AVAILABILITY_FILTER_VALUES.ALL_DAY,
]);
export const DEFAULT_FILTERS = {
    smartRoom: false,
    // "All" is the neutral baseline: meeting rooms, desks, and POIs are shown.
    all: true,
    meetingRooms: false,
    hotDesks: false,
    thisFloor: FLOOR_FILTER_VALUES.ALL_FLOORS,
    accessibleSpace: false,
    roomCapacity: 1,
    availability: AVAILABILITY_FILTER_VALUES.ANY,
    tags: [],
};
// Count only choices that narrow the neutral "All Rooms" result set. The
// default `all` selection is intentionally not counted.
export const getFiltersCount = (filters) => {
    let count = 0;
    if (filters.meetingRooms)
        count++;
    if (filters.hotDesks)
        count++;
    if (filters.thisFloor === FLOOR_FILTER_VALUES.THIS_FLOOR)
        count++;
    if (DURATION_AVAILABILITY_VALUES.has(filters.availability))
        count++;
    if (filters.roomCapacity > 1)
        count++;
    if (filters.smartRoom)
        count++;
    count += filters.tags.length;
    return count;
};
export const filterReducer = (state, action) => {
    switch (action.name) {
        case 'reset':
            return DEFAULT_FILTERS;
        case 'replace':
            return action.value;
        case 'merge':
            // Apply several fields atomically (used for mutually-exclusive space-type
            // checkboxes: selecting a specific type clears "All", and vice versa).
            return Object.assign(Object.assign({}, state), action.value);
        case 'tag':
            if (state.tags.includes(action.value)) {
                return Object.assign(Object.assign({}, state), { tags: state.tags.filter((tag) => tag !== action.value) });
            }
            return Object.assign(Object.assign({}, state), { tags: [...state.tags, action.value] });
        default:
            return Object.assign(Object.assign({}, state), { [action.name]: action.value });
    }
};
